export const logoContainer = 'logo_container';
